import script from "./AppSettingsInitFailed.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSettingsInitFailed.vue?vue&type=script&setup=true&lang=js"

import "./AppSettingsInitFailed.vue?vue&type=style&index=0&id=8f57066c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8f57066c"]])

export default __exports__